import { Div, RefString, CollectionPrinter, Span, TextInput, Button } from "@tblabs/truffle";
import { IChatView } from "../Services/IChatView";
import { MessageBox } from "./MessageBox";
import { ChatEntry } from "../Models/ChatEntry";
import { PicturePack } from "@tblabs/storage";
import { PicsUploader } from "./PicsUploader";


export class ChatViewer extends Div
{
    private newMessage = new RefString();
    private printer: CollectionPrinter<ChatEntry>;

    constructor(private chat: IChatView)
    {
        super("chat-container");

        chat.Messages.OnChange(() =>
        {
            setTimeout(() =>
            {
                this.printer.ScrollToBottom();
            }, 100);
        });

        const sentOrReceived = (entry: ChatEntry) => entry.AuthorId == chat.UserId ? "sent" : "received";
        this.printer = new CollectionPrinter(chat.Messages, entry => new MessageBox(sentOrReceived(entry), entry));

        this.Append(
            this.printer.Class("chat-messages"),
            new Span("- Brak wiadomości -").Margin(32).Italic()
                .VisibleWhen(chat.Messages.CountRef, count => count == 0),
            // new ProgressBar(timer, "#ddd").Invert().Height(8),
            new Div("chat-input").Append(
                new PicsUploader(chat.PicturesDataset)
                    .OnSuccessfulUpload(pics => this.AddPictures(pics)),
                new TextInput(this.newMessage).Placeholder(`Piszesz jako ${chat.UserId}...`)
                    .OnEnterKeyPressed(async () => await this.SendMessage()),
                new Button("Wyślij").RemoveAllClasses()
                    .EnableWhen(this.newMessage, msg => (msg as string).length > 0)
                    .OnClick(async () => await this.SendMessage()),
            )
        );
    }

    private async AddPictures(pics: PicturePack[])
    {
        await this.chat.AddPictures(pics);
    }

    private async SendMessage()
    {
        const text = this.newMessage.value;
        this.newMessage.value = "";
        await this.chat.AddMessage(text);
    }
}
